import { render, staticRenderFns } from "./SpecialRfDgInqPop.vue?vue&type=template&id=b55adad2&scoped=true"
import script from "./SpecialRfDgInqPop.vue?vue&type=script&lang=js"
export * from "./SpecialRfDgInqPop.vue?vue&type=script&lang=js"
import style0 from "./SpecialRfDgInqPop.vue?vue&type=style&index=0&id=b55adad2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55adad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b55adad2')) {
      api.createRecord('b55adad2', component.options)
    } else {
      api.reload('b55adad2', component.options)
    }
    module.hot.accept("./SpecialRfDgInqPop.vue?vue&type=template&id=b55adad2&scoped=true", function () {
      api.rerender('b55adad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/SpecialRfDgInqPop.vue"
export default component.exports